import { ReduxService } from 'dashboard-services/services';

import { basicCustomInsightConsts, chartCustomInsightActions, mapCustomInsightActions } from 'actions/modules/insight';

const CHART_TYPES = chartCustomInsightActions.CHART_TYPES
const emptyMapData = {
  label: "Map Data", 
  geojson: mapCustomInsightActions.GEOJSONS.COUNTRIES.value,
  geojsonType: "shape",
  colorConfiguration: [
    { value: 30, color: basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE.colors[0] },
    { value: 20, color: basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE.colors[1] },
    { value: 15, color: basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE.colors[2] },
    { value: 10, color: basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE.colors[3] },
    { value: 5, color: basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE.colors[4] },
    { value: 2, color: basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE.colors[5] },
    { value: 0, color: basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE.colors[6] },
  ],
  displayAsLegend: false,
  symbolList: [],
  column: undefined,
  chartColor: basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE.colors[0],
  chartType: CHART_TYPES.LINE.value,
  chartAxis: "left",

  chartData: {
    leftAxis: {
      unit: undefined,
      data: [],
      domain: undefined,
      unitOnFront: false
    },
    rightAxis: {
      unit: undefined,
      data: [],
      domain: undefined,
      unitOnFront: false
    }
  }
}

export const mapCustomReducer = (state, action) => {
  switch (action.type) {
    case mapCustomInsightActions.ON_CHANGE_USER_SELECTABLE_DROPDOWNS:
      return ReduxService.updateObject(state, { userSelectableDropdowns: ReduxService.updateObject(state.userSelectableDropdowns, { [action.name]: action.value }) })
    case mapCustomInsightActions.ADD_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).add(Object.assign({} , emptyMapData, { label: `${emptyMapData.label} ${(state.content.mapData.length + 1)}` }))
        })
      })
    case mapCustomInsightActions.REMOVE_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).remove(action.index)
        })
      })
    case mapCustomInsightActions.REORDER_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).moveItem(action.from, action.to)
        })
      })
    case mapCustomInsightActions.DUPLICATE_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).add(ReduxService.updateObject({}, state.content.mapData[action.index]), action.index)
        })
      })
    case mapCustomInsightActions.CHANGE_ELEMENT_IN_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).updateInList({ [action.name]: action.value }, action.index)
        })
      })
    case mapCustomInsightActions.CHANGE_AXIS_IN_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).updateInList({ 
            chartData: ReduxService.updateObject(state.content.mapData[action.index].chartData, {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.mapData[action.index].chartData[action.right ? "rightAxis" : "leftAxis"], {
                [action.name]: action.value
              })
            })
          }, action.index)
        })
      })
    case mapCustomInsightActions.CHANGE_AXIS_IN_SUMMARY:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          summaryConfig: ReduxService.updateObject(state.content.summaryConfig, {
            chartData: ReduxService.updateObject(state.content.summaryConfig.chartData || {}, {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.summaryConfig.chartData?.[action.right ? "rightAxis" : "leftAxis"] || {}, {
                [action.name]: action.value
              })
            })
          })
        })
      })
    case mapCustomInsightActions.CHANGE_DATA_IN_AXIS_IN_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).updateInList({ 
            chartData: ReduxService.updateObject(state.content.mapData[action.index].chartData, {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.mapData[action.index].chartData[action.right ? "rightAxis" : "leftAxis"], {
                data: state.content.mapData[action.index].chartData[action.right ? "rightAxis" : "leftAxis"].data.updateInList({ [action.name]: action.value }, action.dataIndex)
              })
            })
          }, action.index)
        })
      })
    case mapCustomInsightActions.ADD_DATA_TO_AXIS_IN_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).updateInList({ 
            chartData: ReduxService.updateObject(state.content.mapData[action.index].chartData, {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.mapData[action.index].chartData[action.right ? "rightAxis" : "leftAxis"], {
                data: state.content.mapData[action.index].chartData[action.right ? "rightAxis" : "leftAxis"].data.add({ label: "Data", chartType: CHART_TYPES.LINE.value, color: (state.content.mapData[action.index].colorPalette || basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE)?.colors[(1 + state.content.mapData[action.index].chartData.leftAxis.data.length + state.content.mapData[action.index].chartData.rightAxis.data.length)%7] })
              })
            })
          }, action.index)
        })
      })
    case mapCustomInsightActions.REORDER_DATA_FROM_AXIS_IN_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).updateInList({ 
            chartData: ReduxService.updateObject(state.content.mapData[action.mapIndex].chartData, {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.mapData[action.mapIndex].chartData[action.right ? "rightAxis" : "leftAxis"], {
                data: state.content.mapData[action.mapIndex].chartData[action.right ? "rightAxis" : "leftAxis"].data.moveItem(action.from, action.to)
              })
            })
          }, action.mapIndex)
        })
      })
    case mapCustomInsightActions.REMOVE_DATA_FROM_AXIS_IN_MAP_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          mapData: (state.content.mapData || []).updateInList({ 
            chartData: ReduxService.updateObject(state.content.mapData[action.mapIndex].chartData, {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.mapData[action.mapIndex].chartData[action.right ? "rightAxis" : "leftAxis"], {
                data: state.content.mapData[action.mapIndex].chartData[action.right ? "rightAxis" : "leftAxis"].data.remove(action.dataIndex)
              })
            })
          }, action.mapIndex)
        })
      })
    case mapCustomInsightActions.CHANGE_DATA_IN_AXIS_IN_SUMMARY:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          summaryConfig: ReduxService.updateObject(state.content.summaryConfig || {}, {
            chartData: ReduxService.updateObject(state.content.summaryConfig.chartData, {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.summaryConfig.chartData[action.right ? "rightAxis" : "leftAxis"], {
                data: state.content.summaryConfig.chartData[action.right ? "rightAxis" : "leftAxis"].data.updateInList({ [action.name]: action.value }, action.dataIndex)
              })
            })
          })
        })
      })
    case mapCustomInsightActions.ADD_DATA_TO_AXIS_IN_SUMMARY:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          summaryConfig: ReduxService.updateObject(state.content.summaryConfig, {
            chartData: ReduxService.updateObject((state.content.summaryConfig.chartData || {}), {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.summaryConfig.chartData?.[action.right ? "rightAxis" : "leftAxis"] || {}, {
                data: (state.content.summaryConfig.chartData?.[action.right ? "rightAxis" : "leftAxis"]?.data || []).add({ label: "Data", chartType: CHART_TYPES.LINE.value, color: (state.content.mapData?.[0]?.colorPalette || basicCustomInsightConsts.DEFAULT_MAP_COLOR_PALETTE)?.colors[(1 + state.content.summaryConfig.chartData.leftAxis.data.length + state.content.summaryConfig.chartData.rightAxis.data.length)%7] })
              })
            })
          })
        })
      })
    case mapCustomInsightActions.REMOVE_DATA_FROM_AXIS_IN_SUMMARY:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          summaryConfig: ReduxService.updateObject(state.content.summaryConfig, { 
            chartData: ReduxService.updateObject(state.content.summaryConfig.chartData, {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.summaryConfig.chartData[action.right ? "rightAxis" : "leftAxis"], {
                data: state.content.summaryConfig.chartData[action.right ? "rightAxis" : "leftAxis"].data.remove(action.dataIndex)
              })
            })
          })
        })
      })
    case mapCustomInsightActions.REORDER_DATA_FROM_AXIS_IN_SUMMARY:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          summaryConfig: ReduxService.updateObject(state.content.summaryConfig, { 
            chartData: ReduxService.updateObject(state.content.summaryConfig.chartData, {
              [action.right ? "rightAxis" : "leftAxis"]: ReduxService.updateObject(state.content.summaryConfig.chartData[action.right ? "rightAxis" : "leftAxis"], {
                data: state.content.summaryConfig.chartData[action.right ? "rightAxis" : "leftAxis"].data.moveItem(action.from, action.to)
              })
            })
          })
        })
      })
    case mapCustomInsightActions.ON_CHANGE_MAP_CONFIG:
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          mapConfig: ReduxService.updateObject(state.content.mapConfig, { [action.name]: action.value })
         })
      })
    case mapCustomInsightActions.ON_CHANGE_SUMMARY_CONFIG:
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          summaryConfig: ReduxService.updateObject(state.content.summaryConfig, { [action.name]: action.value })
         })
      })
    default:
      return undefined;
  }
}